import { getFullUrl } from "@/utils/url-utils";

/**
 * Helper function to make a GET request to the Next.js API.
 *
 * Will use cookies automatically to authenticate.
 *
 * @param url Starts with /api/ for Next.js API routes.
 * @returns Promise resolving to response.
 */
export async function fetchGETNext(url: string): Promise<Response> {
  const fullUrl = url.startsWith("/api/") ? await getFullUrl(url) : url;

  const response = await fetch(fullUrl, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    // TODO: Disable error toast for now
    // showErrorToast();
  }

  return response;
}

/**
 * Helper function to make a POST request to the Next.js API.
 *
 * Will use cookies automatically to authenticate.
 *
 * @param url starts with /api/ for Next.js API routes
 * @param body request body (will be JSON stringified)
 * @param customHeaders optional additional headers to merge with defaults
 * @returns Promise resolving to response.
 */
export async function fetchPOSTNext(
  url: string,
  body: unknown = undefined,
  customHeaders: HeadersInit = {}
): Promise<Response> {
  const fullUrl = url.startsWith("/api/") ? await getFullUrl(url) : url;

  const defaultHeaders = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const response = await fetch(fullUrl, {
    method: "POST",
    credentials: "include",
    body: body ? JSON.stringify(body) : undefined,
    headers: {
      ...defaultHeaders,
      ...customHeaders,
    },
  });

  if (!response.ok) {
    // TODO: Disable error toast for now
    // showErrorToast();
  }

  return response;
}
